import React, { createContext, useContext, ReactNode } from 'react';
import { Movie } from '../Clients/reminds';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApiClientContext } from './ApiClient.Context';

interface ContextType {
  data: Movie[] | undefined;
  deleteMovie: (id: number) => void;
}

const Context = createContext<ContextType | undefined>(undefined);

export const useMoviesContext = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error('useMoviesContext must be used within a MoviesProvider');
  }
  return context;
};

interface Props {
  children: ReactNode;
}

export const MoviesProvider: React.FC<Props> = ({ children }) => {
  const { moviesClient } = useApiClientContext();
  const queryClient = useQueryClient();

  const { data } = useQuery({
    queryKey: ['movies'],
    queryFn: () => moviesClient.getMovies(),
  });

  const { mutate } = useMutation({
    mutationFn: (id: number) => moviesClient.deleteMovie(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['movies'] });
    },
    onError: error => {
      console.error('Error deleting grocery item:', error);
    },
  });

  return <Context.Provider value={{ data, deleteMovie: mutate }}>{children}</Context.Provider>;
};
